/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Col_MiniappInputs */

const vi_shop_col_miniapp = /** @type {(inputs: Shop_Col_MiniappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mini App`)
};

/**

* @param {Shop_Col_MiniappInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_col_miniapp = /** @type {((inputs?: Shop_Col_MiniappInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Col_MiniappInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_col_miniapp(inputs)
});